var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.75C2 8.7835 2.7835 8 3.75 8H6.25C6.66421 8 7 8.33579 7 8.75C7 9.16421 6.66421 9.5 6.25 9.5H3.75C3.61193 9.5 3.5 9.61193 3.5 9.75V20.25C3.5 20.3881 3.61193 20.5 3.75 20.5H14.25C14.3881 20.5 14.5 20.3881 14.5 20.25V17.75C14.5 17.3358 14.8358 17 15.25 17C15.6642 17 16 17.3358 16 17.75V20.25C16 21.2165 15.2165 22 14.25 22H3.75C2.7835 22 2 21.2165 2 20.25V9.75Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.75C8 2.7835 8.7835 2 9.75 2H20.25C21.2165 2 22 2.7835 22 3.75V14.25C22 15.2165 21.2165 16 20.25 16H9.75C8.7835 16 8 15.2165 8 14.25V3.75ZM9.75 3.5C9.61193 3.5 9.5 3.61193 9.5 3.75V14.25C9.5 14.3881 9.61193 14.5 9.75 14.5H20.25C20.3881 14.5 20.5 14.3881 20.5 14.25V3.75C20.5 3.61193 20.3881 3.5 20.25 3.5H9.75Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.e4c59e87.svg";
export { ForwardRef as ReactComponent };